import { useEffect, useRef } from "react";
import { Navigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { useUser } from "../../hooks";
import { useCompanyCapabilities } from "../../hooks/useCompanyCapabilities";
import {
  canAccessStaffPath,
  isStaffSystemRole,
  resolveStaffHomePath,
} from "../../utils/staffRoleModules";

/**
 * Blocks staff from routes their role modules do not allow.
 */
export default function StaffRoleRoute({ children }) {
  const user = useUser();
  const { capabilities } = useCompanyCapabilities();
  const location = useLocation();
  const role = user?.role;
  const allowed = canAccessStaffPath(location.pathname, role);
  const homePath = resolveStaffHomePath(role, capabilities);
  const lastToastPath = useRef(null);

  useEffect(() => {
    if (!allowed && role && lastToastPath.current !== location.pathname) {
      lastToastPath.current = location.pathname;
      toast.error("You do not have permission to access this page.");
    }
    if (allowed) {
      lastToastPath.current = null;
    }
  }, [allowed, role, location.pathname]);

  if (!role?.modules && !isStaffSystemRole(role)) {
    return children;
  }

  if (!allowed) {
    return <Navigate to={homePath} replace />;
  }

  return children;
}
